import { Box, Button } from "@mui/material";

import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import * as z from "zod";

import { useUpdateAuthenticatedUserUserPatchMutation } from "api";
import { TextInput } from "components/forms";
import { SectionCard } from "components/SectionCard/SectionCard";
import { IUser } from "interfaces/user.interface";

const userFormSchema = z.object({
  first_name: z.string(),
  last_name: z.string(),
  profession: z.string().optional(),
  email: z.string(),
});

export type UserFormSchema = z.infer<typeof userFormSchema>;

type UserFormProps = {
  user: Omit<IUser, "zones">;
};

export function UserForm({ user }: UserFormProps) {
  const { t } = useTranslation();

  const [updateUser] = useUpdateAuthenticatedUserUserPatchMutation();

  const { control, handleSubmit } = useForm<UserFormSchema>({
    resolver: zodResolver(userFormSchema),
    defaultValues: {
      first_name: user.first_name ?? "",
      last_name: user.last_name ?? "",
      profession: user.profession ?? "",
      email: user.email,
    },
  });

  const onSubmit = (data: UserFormSchema) => {
    updateUser({ userSelfUpdate: data });
  };

  return (
    <Box component={"form"} onSubmit={handleSubmit(onSubmit)}>
      <SectionCard title={t("employee_information")}>
        <TextInput
          label={t("First Name")}
          placeholder={t("user_first_name_placeholder")}
          fieldName={"first_name"}
          control={control}
        />
        <TextInput
          label={t("Last Name")}
          placeholder={t("user_last_name_placeholder")}
          fieldName={"last_name"}
          control={control}
        />
        <TextInput
          label={t("Email")}
          placeholder={t("user_email_placeholder")}
          fieldName={"email"}
          control={control}
        />
        <TextInput
          label={t("Job Title")}
          placeholder={t("user_title_placeholder")}
          fieldName={"profession"}
          control={control}
        />
        <Button type={"submit"}>{t("Save")}</Button>
      </SectionCard>
    </Box>
  );
}
